/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createVersion } from '../../factoriesAny.js';
export var versionDependencies = {
  createVersion: createVersion
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesVersion.generated.js
// module id = 1545
// module chunks = 0